module.exports = __webpack_public_path__ + "assets/84eb2373f684bb1ee06c69df2946cecd.png";